import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import TileComponent from "../../components/TileComponent/TileComponent";
import FounderMessage from "../../components/FounderMessage/FounderMessage";
import HeroComponent from "../../components/HeroComponent/HeroComponent";
import PerksBenefits from "../../components/PerksBenefits/PerksBenefits";
import KnowMoreSection from "../../components/KnowMoreSection/KnowMoreSection";
import WhatIsClassplus from "../../components/WhatIsClassplus/WhatIsClassplus";
import InvestorsSection from "../../components/InvestorsSection/InvestorsSection";

import { OtherDataActions } from "../../store/OtherDataSlice";
const LandingPage = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		let url_string = window.location.href;
		let url = new URL(url_string);
		let utm_source = url.searchParams.get("utm_source");
		let utm_medium = url.searchParams.get("utm_medium");
		let utm_campaign = url.searchParams.get("utm_campaign");
		const utmData = [
			{
				utm_source,
				utm_medium,
				utm_campaign,
			},
		];
		dispatch(OtherDataActions.setUtmData(utmData));
	}, [dispatch]);
	return (
		<>
			<HeroComponent />
			<WhatIsClassplus />
			<TileComponent />
			<FounderMessage />
			<PerksBenefits />
			<InvestorsSection />
			<KnowMoreSection />
		</>
	);
};

export default LandingPage;
